export const calculateOverlayPosition = (size: number, position: number): number => size / 2 - (size * position) / 2;
export const calculateOverlaySize = (size: number, position: number): number => size * position;
